<template>
  <v-dialog v-model="dialogComputed" scrollable>
    <v-card v-if="dialogComputed">
      <v-card-title class="primary white--text py-2">
        {{ $t('ELE0152') }}
        <v-spacer />
        <Btn icon="mdi-close" @click="onClickClose" depressed iconProp color="white" />
      </v-card-title>
      <v-container fluid>
        <v-card flat>
          <v-row>
            <v-col cols="3">
              <TextFieldRef :label="$t('ELE0134')" :value="manufacturerCompanyName" />
            </v-col>
            <v-col cols="3">
              <TextFieldRef :label="$t('ELE0031')" :value="partCd" />
            </v-col>
            <v-col cols="3">
              <TextFieldRef :label="$t('ELE0049')" :value="lotNo" />
            </v-col>
          </v-row>
        </v-card>
        <v-card outlined>
          <v-card-title>
            {{ $t('ELE0023') }}
          </v-card-title>
          <v-card-text>
            <v-data-table :headers="headers" :items="items" dense> </v-data-table>
          </v-card-text>
        </v-card>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'

import Btn from '@/components/atoms/base/button/Btn'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'

export default {
  name: 'SearchInspLotDtlDialog',

  mixins: [APIUtils, Message, Loading, DateUtils],

  components: {
    Btn,
    TextFieldRef,
  },

  props: {
    dialog: {
      type: Boolean,
      default: false,
      required: true,
    },
    manufacturerCd: {
      type: String,
      required: true,
    },
    manufacturerCompanyName: {
      type: String,
      required: true,
    },
    lotNo: {
      type: String,
      required: true,
    },
    partCd: {
      type: String,
      required: true,
    },
    acceptCompanyCd: {
      type: String,
      required: true,
    },
    inspIndexNo: {
      type: String,
      required: true,
    },
  },

  computed: {
    dialogComputed: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
  },

  data() {
    return {
      items: [],
      headers: [
        { text: this.$t('ELE0056'), value: 'refNo', divider: true },
        { text: this.$t('ELE0150'), value: 'qty', divider: true, align: 'end' },
        { text: this.$t('ELE0055'), value: 'acceptDatetime', divider: true },
        { text: this.$t('ELE0054'), value: 'remarks' },
      ],
    }
  },

  watch: {
    dialog() {
      if (this.dialog) {
        this.search()
      }
    },
  },

  methods: {
    onClickClose() {
      this.dialogComputed = false
    },
    async search() {
      this.startLoading()
      try {
        const params = {
          manufacturerCd: this.manufacturerCd,
          partCd: this.partCd,
          lotNo: this.lotNo,
          inspIndexNo: this.inspIndexNo,
          acceptCompanyCd: this.acceptCompanyCd,
        }
        this.items = []
        const elements = await API.get('/box/inspBoxes', params)
        elements.forEach((element) => {
          element['acceptDatetime'] = this.toLocalTime(element['acceptDatetime'])
          this.items.push(element)
        })
      } catch (error) {
        this.items = []
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0078') })))
      } finally {
        this.stopLoading()
      }
    },
  },

  mounted() {
    this.search()
  },
}
</script>
